import { waitDialog } from 'dialogs';
import type { CreateTarget } from 'actions';
import EditPythonLibraryModal from '../EditPythonLibraryModal';

export type ShowEditPythonLibraryArgs = { readonly mode: 'create'; readonly createIn?: CreateTarget } | { readonly mode: 'edit'; readonly id: number };

/**
 * Open the Python library create / edit modal and resolve when it closes (so the
 * caller can refresh). `EditPythonLibraryModal` loads the record + its node-def
 * links from the id itself, so no record needs threading through — only the id.
 */
export const showEditPythonLibrary = async (args: ShowEditPythonLibraryArgs): Promise<void> => {
  const libraryId = args.mode === 'edit' ? args.id : undefined;
  const createIn = args.mode === 'create' ? args.createIn : undefined;
  await waitDialog<void>((ok) => <EditPythonLibraryModal show handleClose={ok} mode={args.mode} libraryId={libraryId} createIn={createIn} />);
};
